import { Typography } from '@material-ui/core';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { WebViewLink } from 'shared/routing/WebViewLinks';

const disclaimerLink =
  'https://www.superdispatch.com/terms-of-service#tab-id-2';

export function PostingWaiver() {
  return (
    <Typography variant="caption" aria-label="Waiver">
      By {MobileAppBridge.isInjected() ? 'tapping' : 'clicking'} this button,
      you are agreeing to our standard{' '}
      <WebViewLink
        target="_blank"
        href={disclaimerLink}
        rel="noopener noreferrer"
      >
        waiver
      </WebViewLink>
      .
    </Typography>
  );
}
